import { NotificationState, NotificationTypes, NotificationActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: NotificationState = {
  notifications: { items: [] }
}

type ReducerOpts = Reducer<NotificationState, NotificationActionTypes>
const reducer: ReducerOpts = (state = initialState, action: NotificationActionTypes): NotificationState => {
  let index = -1
  switch (action.type) {
    case NotificationTypes.NOTIFICATION_CREATE:
      return {
        ...state,
        notifications: { ...state.notifications, items: [...state.notifications.items, action.payload] }
      }
    case NotificationTypes.NOTIFICATION_UPDATE:
      index = state.notifications.items.findIndex(obj => obj.id === action.payload.id)
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: [
            ...state.notifications.items.slice(0, index),
            action.payload,
            ...state.notifications.items.slice(index + 1)
          ]
        }
      }
    case NotificationTypes.NOTIFICATION_DELETE:
      index = state.notifications.items.findIndex(obj => obj.id === action.payload)
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: [
            ...state.notifications.items.slice(0, index),
            ...state.notifications.items.slice(index + 1)
          ]
        }
      }
    case NotificationTypes.NOTIFICATION_GET:
      return { ...state, notification: action.payload }
    case NotificationTypes.NOTIFICATION_GET_LIST:
      return { ...state, notifications: { items: action.payload, pagination: action.pagination } }
    default:
      return state
  }
}

export default reducer
